/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-22 15:54:31
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-03-23 15:40:11
 * @FilePath: /knit-web/src/locale/en-US/common.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  common: {
    login: 'Login',
    submit: 'Submit',
    reject: 'Reject',
    cancel: 'Cancel',
    save: 'Save',
    ok: 'OK',
    reset: 'Reset',
    publish: 'Publish',
    deleteSuccess: 'Delete Successfully',
    deleteFailed: 'Delete Failed',
    copySuccess: 'Copy Successfully',
    copyFailed:
      'Copy failed, your browser may not support or has disabled this operation',
    getFailed: 'Failed to get data',
    time: {
      justNow: 'Just now',
      yearsAgo: '{count} years ago',
      monthsAgo: '{count} months ago',
      daysAgo: '{count} days ago',
      hoursAgo: '{count} hours ago',
      minutesAgo: '{count} minutes ago',
      secondsAgo: '{count} seconds ago',
    },
    credits: 'Credits',
    overview: 'Overview',
    search: 'Search',
    pleaseInput: 'Please input {name}',
    pleaseSelect: 'Please select {name}',
    goToExternalConfiguration: 'Go to External Configuration',
    required: '{name} is required',
    unknownError: 'Unknown Error',
    userDisabled: {
      title: 'Account Disabled',
      content:
        'Your account has been disabled. Please contact your administrator.',
    },
    documentation: 'Documentation',
    contactUs: 'Contact Us',
    logOut: 'Log out',
    debugSettings: 'Debug Settings',
    deleteConfirmTitle: 'Delete Confirmation',
    workspaceLimitExceeded:
      'You can create up to {max} workspaces. Please delete an existing workspace first.',
  },
  exception: {
    result: {
      403: {
        description: 'Your account has been disabled',
        detail:
          'Your account has been disabled after an automatic review of your recent activities. Please take a look at our Terms of Service and Usage Policy for more information. If you wish to appeal your suspension, please contact the administrator.',
        back: 'Back to Login',
      },
    },
  },
  workspaceLimitExceeded:
    'You can create up to {max} workspaces. Please delete an existing workspace first.',
  columnsShowSelector: {
    title: 'Column Management',
    columnName: 'Column Name',
  },
};
